import React from "react";
import { CheckCircle2 } from "lucide-react";

interface SubmittedWordDisplayProps {
  word: string;
  showCheckmark: boolean;
  userHasSubmitted?: boolean;
  botHasChosen?: boolean;
}

export const SubmittedWordDisplay: React.FC<SubmittedWordDisplayProps> = ({
  word,
  showCheckmark,
  userHasSubmitted = false,
  botHasChosen = false
}) => {
  // If user has submitted but bot hasn't chosen yet, show checkmark in center
  if (userHasSubmitted && !botHasChosen) {
    return (
      <div className="w-full h-full relative flex items-center justify-center">
        <CheckCircle2 className="h-5 w-5 text-green-500" />
      </div>
    );
  }
  
  // Otherwise just show the word
  return (
    <div className="w-full h-full relative flex items-center justify-center">
      <span>{word.toLowerCase() || "..."}</span>
    </div>
  );
};
